import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div id="revision-controls">
  <div class="revision-controls--back">
    <DButton
      class="btn-default first-revision"
      @action={{@loadFirstVersion}}
      @icon="fast-backward"
      @title="post.revisions.controls.first"
      @disabled={{@loadFirstDisabled}}
    />
    <DButton
      class="btn-default previous-revision"
      @action={{@loadPreviousVersion}}
      @icon="backward"
      @title="post.revisions.controls.previous"
      @disabled={{@loadPreviousDisabled}}
    />
  </div>
  <div id="revision-numbers" class={{unless @displayRevisions "invisible"}}>
    <ConditionalLoadingSpinner @condition={{@loading}} @size="small">
      {{html-safe @revisionsText}}
    </ConditionalLoadingSpinner>
  </div>
  <div class="revision-controls--forward">
    <DButton
      class="btn-default next-revision"
      @action={{@loadNextVersion}}
      @icon="forward"
      @title="post.revisions.controls.next"
      @disabled={{@loadNextDisabled}}
    />
    <DButton
      class="btn-default last-revision"
      @action={{@loadLastVersion}}
      @icon="fast-forward"
      @title="post.revisions.controls.last"
      @disabled={{@loadLastDisabled}}
    />
  </div>
</div>

<div id="revision-footer-buttons">
  {{#if @displayEdit}}
    <DButton
      @action={{@editPost}}
      @icon="pencil-alt"
      class="btn-default edit-post"
      @label={{@editButtonLabel}}
    />
  {{/if}}

  {{#if @isStaff}}
    {{#if @revertToRevisionText}}
      <DButton
        @action={{@revertToVersion}}
        @icon="undo"
        @translatedLabel={{@revertToRevisionText}}
        class="btn-danger revert-to-version"
        @disabled={{@loading}}
      />
    {{/if}}

    {{#if @model.previous_hidden}}
      <DButton
        @action={{@showVersion}}
        @icon="far-eye"
        @label="post.revisions.controls.show"
        class="btn-default show-revision"
        @disabled={{@loading}}
      />
    {{else}}
      <DButton
        @action={{@hideVersion}}
        @icon="far-eye-slash"
        @label="post.revisions.controls.hide"
        class="btn-danger hide-revision"
        @disabled={{@loading}}
      />
    {{/if}}

    {{#if (and @canPermanentlyDelete @model.previous_hidden)}}
      <DButton
        @action={{@permanentlyDeleteVersions}}
        @icon="far-trash-alt"
        @label="post.revisions.controls.destroy"
        class="btn-danger destroy-revision"
        @disabled={{@loading}}
      />
    {{/if}}
  {{/if}}
</div>
*/
{
  "id": "eWIbDhNs",
  "block": "[[[10,0],[14,1,\"revision-controls\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"revision-controls--back\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"btn-default first-revision\"]],[[\"@action\",\"@icon\",\"@title\",\"@disabled\"],[[30,1],\"fast-backward\",\"post.revisions.controls.first\",[30,2]]],null],[1,\"\\n    \"],[8,[39,0],[[24,0,\"btn-default previous-revision\"]],[[\"@action\",\"@icon\",\"@title\",\"@disabled\"],[[30,3],\"backward\",\"post.revisions.controls.previous\",[30,4]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,1,\"revision-numbers\"],[15,0,[52,[51,[30,5]],\"invisible\"]],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@condition\",\"@size\"],[[30,6],\"small\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[[30,7]],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"revision-controls--forward\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"btn-default next-revision\"]],[[\"@action\",\"@icon\",\"@title\",\"@disabled\"],[[30,8],\"forward\",\"post.revisions.controls.next\",[30,9]]],null],[1,\"\\n    \"],[8,[39,0],[[24,0,\"btn-default last-revision\"]],[[\"@action\",\"@icon\",\"@title\",\"@disabled\"],[[30,10],\"fast-forward\",\"post.revisions.controls.last\",[30,11]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,1,\"revision-footer-buttons\"],[12],[1,\"\\n\"],[41,[30,12],[[[1,\"    \"],[8,[39,0],[[24,0,\"btn-default edit-post\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,13],\"pencil-alt\",[30,14]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,15],[[[41,[30,16],[[[1,\"      \"],[8,[39,0],[[24,0,\"btn-danger revert-to-version\"]],[[\"@action\",\"@icon\",\"@translatedLabel\",\"@disabled\"],[[30,17],\"undo\",[30,16],[30,6]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,18,[\"previous_hidden\"]],[[[1,\"      \"],[8,[39,0],[[24,0,\"btn-default show-revision\"]],[[\"@action\",\"@icon\",\"@label\",\"@disabled\"],[[30,19],\"far-eye\",\"post.revisions.controls.show\",[30,6]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,0],[[24,0,\"btn-danger hide-revision\"]],[[\"@action\",\"@icon\",\"@label\",\"@disabled\"],[[30,20],\"far-eye-slash\",\"post.revisions.controls.hide\",[30,6]]],null],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[28,[37,5],[[30,21],[30,18,[\"previous_hidden\"]]],null],[[[1,\"      \"],[8,[39,0],[[24,0,\"btn-danger destroy-revision\"]],[[\"@action\",\"@icon\",\"@label\",\"@disabled\"],[[30,22],\"far-trash-alt\",\"post.revisions.controls.destroy\",[30,6]]],null],[1,\"\\n\"]],[]],null]],[]],null],[13]],[\"@loadFirstVersion\",\"@loadFirstDisabled\",\"@loadPreviousVersion\",\"@loadPreviousDisabled\",\"@displayRevisions\",\"@loading\",\"@revisionsText\",\"@loadNextVersion\",\"@loadNextDisabled\",\"@loadLastVersion\",\"@loadLastDisabled\",\"@displayEdit\",\"@editPost\",\"@editButtonLabel\",\"@isStaff\",\"@revertToRevisionText\",\"@revertToVersion\",\"@model\",\"@showVersion\",\"@hideVersion\",\"@canPermanentlyDelete\",\"@permanentlyDeleteVersions\"],false,[\"d-button\",\"unless\",\"conditional-loading-spinner\",\"html-safe\",\"if\",\"and\"]]",
  "moduleName": "discourse/components/modal/history/topic-footer.hbs",
  "isStrictMode": false
});